// angular
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
// components
import { SolutionsPeopleBrowseComponent } from '@app/+solutions/components/solutions-people-browse/solutions-people-browse.component';

@Component({
  selector: 'pwj-architects',
  standalone: true,
  imports: [TranslateModule, SolutionsPeopleBrowseComponent],
  templateUrl: './architects.component.html',
  styleUrl: './architects.component.scss',
})
export class ArchitectsComponent {}
